module.exports = __webpack_public_path__ + "img/location.471f7ba1.svg";